import { Stack, Typography, useMediaQuery } from "@mui/material";
import patronSaintConstants from "../../data/about/patronSaint.json";
import { baseurl } from "../../config";

type Props = {};

const PatronSaint = (props: Props) => {
  const mobile = useMediaQuery("(max-width:400px)");
  const tab = useMediaQuery("(max-width:564px)");
  const isSmallScreen = useMediaQuery("(max-width:650px)");
  return (
    <Stack direction="column" spacing={2}>
      <Typography variant="h4" sx={{ fontFamily: "inherit" }}>
        {patronSaintConstants?.title}
        <br />
        <Typography variant="body2" sx={{ fontFamily: "inherit" }}>
          {patronSaintConstants?.subtitle}
        </Typography>
      </Typography>
      {mobile ? (
        <img
          src={`${baseurl}${patronSaintConstants?.emblem}`}
          alt={`${patronSaintConstants?.title}`}
          width="200px"
          style={{
            margin: isSmallScreen ? "1rem auto" : "1.5rem auto",
            borderRadius: "282px 282px 0px 0px",
          }}
        />
      ) : tab ? (
        <img
          src={`${baseurl}${patronSaintConstants?.emblem}`}
          alt={`${patronSaintConstants?.title}`}
          width="292px"
          style={{ margin: "auto", borderRadius: "282px 282px 0px 0px" }}
        />
      ) : (
        <img
          src={`${baseurl}${patronSaintConstants?.emblem}`}
          alt={`${patronSaintConstants?.title}`}
          width="564px"
          style={{ margin: "auto", borderRadius: "282px 282px 0px 0px" }}
        />
      )}

      <Stack direction="column" spacing={2}>
        {patronSaintConstants?.description?.map(
          (desc: string, index: number) => (
            <Typography
              sx={{ fontFamily: "inherit" }}
              variant="body2"
              textAlign="justify"
              key={index}
            >
              {desc}
            </Typography>
          )
        )}
      </Stack>
    </Stack>
  );
};

export default PatronSaint;
